/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_Dim_Structured_DataInputs */

const en_directory_hubs_signals_geo_dim_structured_data = /** @type {(inputs: Directory_Hubs_Signals_Geo_Dim_Structured_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON-LD schema (product, FAQ, breadcrumbs) that states explicitly what the page is about.`)
};

const zh_directory_hubs_signals_geo_dim_structured_data = /** @type {(inputs: Directory_Hubs_Signals_Geo_Dim_Structured_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON-LD 结构化数据（产品、FAQ、面包屑），明确告诉机器这个页面讲什么。`)
};

/**
* | output |
* | --- |
* | "JSON-LD schema (product, FAQ, breadcrumbs) that states explicitly what the page is about." |
*
* @param {Directory_Hubs_Signals_Geo_Dim_Structured_DataInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_dim_structured_data = /** @type {((inputs?: Directory_Hubs_Signals_Geo_Dim_Structured_DataInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_Dim_Structured_DataInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_dim_structured_data(inputs)
	return zh_directory_hubs_signals_geo_dim_structured_data(inputs)
});
export { directory_hubs_signals_geo_dim_structured_data as "directory.hubs.signals.geo.dim.structured_data" }